import React from 'react';
import axios from "axios";
import axiosConfig from '../../config/axios.config';

const CommonTerms = (props) => {
  const [terms, setTerms] = React.useState(false)
  const callControl = React.useRef({
    terms: false
  })

  if(!terms && !callControl.current.terms && props.term) {
    callControl.current.terms = true;
    axios.post(`${axiosConfig.apiUrl}/rt/get-related-terms`, props.term).then(ts => {
      if(ts.data) setTerms(ts.data)
    })
  }

  return <div style={{
    margin: 3,
    padding: '5px 10px',
    maxHeight: 250,
    overflowY: 'scroll'
  }}>
    <h2>Related terms for {props.term.name1}</h2>
    {terms && <ul>
      {terms.map((t,i) => <li key={i} style={{fontSize: 15, marginBottom: 3}}>{t.keyword}</li>)}
    </ul>}
  </div>
}

export default CommonTerms;
